import type { IntlShape } from 'react-intl';

import type {
  IWorkJourneyManagementDayReportItem,
  TWorkJourneyManagementDayReportStatus,
} from '@src/models/interfaces/workJourneyManagement.interface';

const STATUS_LABEL_ID: Record<TWorkJourneyManagementDayReportStatus, string> = {
  present: 'workJourney.management.calendar.dayReport.status.present',
  justified_absence: 'workJourney.management.calendar.dayReport.status.justifiedAbsence',
  unjustified_absence: 'workJourney.management.calendar.dayReport.status.unjustifiedAbsence',
};

const REASON_LABEL_ID: Record<string, string> = {
  vacation: 'workJourney.management.matrix.legend.vac',
  medical_leave: 'absences.type.medical.leave',
  holiday: 'workJourney.management.calendar.sidebar.issue.holiday',
  justified_absence: 'workJourney.management.matrix.legend.auj',
  unjustified_absence: 'workJourney.management.matrix.legend.aui',
  paid_leave: 'workJourney.management.calendar.dayReport.reason.paidLeave',
  unpaid_leave: 'workJourney.management.calendar.dayReport.reason.unpaidLeave',
  prenatal: 'workJourney.management.calendar.dayReport.reason.prenatal',
  postnatal: 'workJourney.management.calendar.dayReport.reason.postnatal',
  shift_replacement: 'workJourney.management.matrix.legend.rem',
  other_absence: 'absences.type.other',
};

export const formatDayReportStatusLabel = (
  status: TWorkJourneyManagementDayReportStatus,
  formatMessage: IntlShape['formatMessage'],
): string => formatMessage({ id: STATUS_LABEL_ID[status] });

export const formatDayReportStatusDetail = (
  item: Pick<IWorkJourneyManagementDayReportItem, 'status' | 'statusReason'>,
  formatMessage: IntlShape['formatMessage'],
): string => {
  const statusLabel = formatDayReportStatusLabel(item.status, formatMessage);
  if (item.status === 'present') {
    return statusLabel;
  }

  const reasonKey =
    typeof item.statusReason === 'string' ? item.statusReason.trim() : '';
  if (!reasonKey || reasonKey === item.status) {
    return statusLabel;
  }

  const reasonId = REASON_LABEL_ID[reasonKey];
  const reasonLabel = reasonId
    ? formatMessage({ id: reasonId })
    : reasonKey;

  return formatMessage(
    { id: 'workJourney.management.calendar.dayReport.statusWithReason' },
    { status: statusLabel, reason: reasonLabel },
  );
};
